import { InputNumber } from "antd";
import styled from "styled-components";

export const StyledInputNumber = styled(InputNumber)<{ textAlign?: string }>`
    height: 44px;
    border-radius: 4px;
    min-width: 70px;
    .ant-input-number-input {
        text-align: ${(props) => props?.textAlign || "center"};
        padding-top: 10px;
    }
`;
